///home/amani/yai4digit-library/frontend/yai4ottoman/src/axios-client.js
import axios from 'axios';
import {SUPER_ADMIN_ROLE} from "./utlis/constant";
import i18n from "./config/i18n";
const baseURL = window?.appConfig?.REACT_APP_API_GATEWAY || process.env.REACT_APP_API_GATEWAY;
const chatbotBaseURL = window?.appConfig?.REACT_APP_CHATBOT || process.env.REACT_APP_CHATBOT;
const currentLang = i18n.language;

const axiosClient = axios.create({
    baseURL: `${baseURL}/api/`,
});

const axiosChatbotClient = axios.create({
    baseURL: `${chatbotBaseURL}/api/v1/`,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const login = (email, password, role) => {
    return axiosClient.post('login', { email, password, role });
};


export const logout = () => {

    return axiosClient.post('logout');
};

export const acceptEula = () => {

    return axiosClient.post('/accept-eula');
};
export const register = (formData) => {
    const { name, email, password, departments, isFreeAgent, language = currentLang, } = formData;

        return axiosClient.post('register', {
            name,
            email,
            password,
            departments: departments,
            isFreeAgent: isFreeAgent,
            language
        });
};

const getToken = () => localStorage.getItem('token');

axiosClient.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
    (response) => response,
    (error) => {

        if (error.response) {

            if (error.response.status === 401 && error.config.url != "login") {

                localStorage.removeItem('token');
                window.location.href = `/${currentLang}/authentication/sign-in`;
            } else if (error.response.status === 403) {

                window.location.href = `/${currentLang}/dashboard`;
            }
        } else {
            console.error('An error occurred:');
        }
        return Promise.reject(error);
    }
);

export const getDigitizationCount = () => {
    return  axiosClient.get(`digitization-count`)
};

export const activateUsers = (ids, data) => {
    return  axiosClient.put(`activate-users/${ids}`, data)
};

export const getFreeAgentsList = (params) => {
    return axiosClient.get('free-agents'+ params);
};

export const getProfile = (role) => {

    if (role === SUPER_ADMIN_ROLE) {

        return axiosClient.get('admin-profile');
    } else {

        return axiosClient.get('user-profile');
    }
};
export const updateProfile = (id, updatedData, role) => {

    if (role === SUPER_ADMIN_ROLE) {

        return axiosClient.put(`/admins/${id}`, updatedData);
    } else {

        return axiosClient.put(`/users/${id}`, updatedData);
    }
};

export const updateCredits = (id, credits) => {
    return axiosClient.put(`/users/${id}/update-credits`, credits);
}

export const getDigitizations = (params) => {

    return axiosClient.get('digitizations' + params);
};

export const getFreeAgentDigitizations = (params) => {
    return axiosClient.get('free-agent-digitizations' + params);
};

export const getUserDocuments = (params) => {

    return axiosClient.get('my-documents' + params);
};

export const getDigitizationResult = (id) => {
    return axiosClient.get(`/digitization-result/${id}`)
}


export const getOrdersList = (params= "") => {

    return axiosClient.get('payment-list' + params);
};

export const getArchivesByPeriod = (params) => {

    return axiosClient.get('digitizations-by-period' + params);
};

export const getDigitizationsReport = (params = '') => {
    return axiosClient.get(`digitizations-statistics-by-period${params}`);
};

export const exportDigitizationsReport = (params = '') => {
    return axiosClient.get(`digitizations-statistics-export${params}`);
};

export const getArchivesById = (id) => {
    return axiosClient.get(`digitizations/${id}`);
};
export const scheduleDownload = (id, title, selectedOptions) => {
    return axiosClient.post(`schedule_download/${id}`, {title: title, selectedOptions: selectedOptions});
};
export const getExportedDocuments = (data) => {
    return axiosClient.post(`get-exported-documents`, data);
};
export const downloadFile = (data) => {
    return axiosClient.post(`download_file`, data, { responseType: 'blob' });
};

export const deleteFile = (title) => {
    return axiosClient.post(`delete_file`, {title: title});
};

export const getArchivesResultById = (id, numPage) => {
    return axiosClient.get(`digitizations-result/${id}/pages/${numPage}`);
};

export const getSubjects = (lang = 'en', params = '') => {
    const queryString = params || `?lang=${lang}`;
    return axiosClient.get(`subjects${queryString}`);
};

export const getServices = (lang = 'en', params = '') => {
    const queryString = params || `?lang=${lang}`;
    return axiosClient.get(`digitizations/services${queryString}`);
};
export const getAllServices = (params = '') => {
    return axiosClient.get(`services${params}`)
};

export const updateService = (serviceId, updatedFields) => {
    return axiosClient.patch(`services/${serviceId}`, updatedFields);
};

export const getOcrModes = (lang = 'en', params = '') => {
    const queryString = params || `?lang=${lang}`;
    return axiosClient.get(`/digitizations/ocr-modes${queryString}`);
};
export const getOutputFormat = (lang = 'en', params = '') => {
    const queryString = params || `?lang=${lang}`;
    return axiosClient.get(`/output-formats${queryString}`);
};

export const getNonExecutedServices = (id, lang = 'en', params = '') => {
    const queryString = params || `?lang=${lang}`;
    return axiosClient.get(`/digitizations/${id}/non-executed-services${queryString}`)
};

export const runSelectedServices = (id, data) => {
    return axiosClient.post(`/digitizations/${id}/services`, data)
};

export const addSubject = (data) => {
    return axiosClient.post('subjects', data)
};

export const digitize = (data) => {
    return axiosClient.post('digitizations', data)
};

export const rerunService = (digitization_id,data) => {
    return axiosClient.post(`rerun-digitizer/${digitization_id}`, data)
};

export const skipService = (digitization_id, data) => {
    return axiosClient.post(`digitization/${digitization_id}/skip-service`, data)
};


export const createArticle = (data) => {
    return axiosClient.post('articles', data)
};

export const deleteArticle = (article_id) => {
    return axiosClient.delete(`/digitizations/${article_id}`);
};


export const forgotPassword = (email, language = 'en') => {
    return axiosClient.post('password-reset-request', { email, language });
};



export const UpdatePassword = (token, new_password, confirm_password) => {
    return axiosClient.post('password-reset-confirm', { 
      token, 
      new_password, 
      confirm_password 
})};

export const getStatistics = () => {
    return axiosClient.get('statistics');
};
export const checkDuplicatedArticles = (params) => {
    return axiosClient.get('check-duplicated-articles', params);
};

export const getOrdersReport = () => {
    return axiosClient.get('orders-report');
};

export const createOrder = (processIds, paymentSource) => {
    return axiosClient.post(`/create-order`, {digitization_process_ids: processIds, payment_source: paymentSource});
};

export const createOrderWithCredits = (processIds, paymentSource) => {
    return axiosClient.post(`/create-order-with-credits`, {digitization_process_ids: processIds, payment_source: paymentSource});
};

export const captureOrder = (orderId) => {
    return axiosClient.post(`/capture-order/${orderId}`);
};

export const deleteSelectedServiceProcess = (digitizationId, serviceId) => {
    return axiosClient.delete(`/digitization-processes/remove-pending-service`,  {
        data: { digitizationId:digitizationId, serviceId: serviceId },
        headers: { 'Content-Type': 'application/json' }
    })
}

export const rerunDigitizer = (digitizationId, data) => {
    return axiosClient.post(`/rerun-digitizer/${digitizationId}`, data);
};

export const refundPayment = (orderId, refundAmount, description) => {
    return axiosClient.post(`/refund_payment/${orderId}`, {refund_amount: refundAmount, description: description});
};

export const submitDigitizationFeedback = (feedback) => {
    return axiosClient.post("feedback", feedback);
};

export const getUsersFeedbacks = (params = '') => {
    return axiosClient.get("get-feedbacks" + params);
}

export const getDigitizationsRatings = () => {
    return axiosClient.get("get-digitizations-ratings" );
}


export const updatePagesDataByArticleId = (article_id, data) => {
    return axiosClient.put(`/article/${article_id}/update-pages`, data);
};

export const regenerateAudioPerPage = (article_id, data) => {
    return axiosClient.put(`/article/${article_id}/regenerate-audio`, data);
};

export const updateMetadata = (id, updatedMetadata) => {
    return axiosClient.patch(`/digitizations/${id}`, updatedMetadata);
};

export const downloadAudio = (articleId, title) => {
    return axiosClient.post(`/article/${articleId}/download-audio`, {title: title});
};

export const extractPageCount = (file) => {
    const data = new FormData();
    data.append('file', file);
    return axiosClient.post('get_page_count', data);
};

export const translateArticle = (payload) => {
    return axiosClient.post(`/regenerate-translation`, payload);
};

export const regenerateSelectedServices = (payload) => {
    return axiosClient.post(`/regenerate-service-results`, payload);
};

export const getServicesToRegenerate = (digitizationId) => {
    return axiosClient.get(`/get-services-to-regenerate/${digitizationId}`);
};

export const translateText = (text, target_language = "Arabic") => {
  return axiosClient.post("text-translation", { text, target_language });
};
export const saveTranslation = (payload) => {
    return axiosClient.post("/create_translation_digitization", payload);
};

export const createConversation = (userUuid) => {
    return axiosChatbotClient.post("conversations", {
        user_uuid: userUuid,
    });
};

export const listConversations = (userUuid) => {
    return axiosChatbotClient.get("conversations", {
        params: { user_uuid: userUuid },
    });
};

export const renameConversation = (conversationId, title) => {
    return axiosChatbotClient.patch(`conversations/${conversationId}`, { title });
};

export const deleteConversation = (conversationId) => {
    return axiosChatbotClient.delete(`conversations/${conversationId}`);
};

export const getConversationMessages = (conversationId, page = 1, limit = 50) => {
    return axiosChatbotClient.get(`conversations/${conversationId}/messages`, {
        params: { page, limit },
    });
};

export const askQuestion = (question, userUuid, conversationId) => {
    return axiosChatbotClient.post("answer", {
        question,
        user_uuid: userUuid,
        conversation_id: conversationId,
    });
};